export default "__VITE_ASSET__ad82e440__"